import MyDnaButton from './MyDnaButton'

export default MyDnaButton; 